import React from 'react';

import './App.css';
import DreamTeam from './DreamTeam.js';

class App extends React.Component
{
  render()
  {
    return (
		<div className="App" style={{display: "inline-block"}}>
			<DreamTeam />
		</div>
	);
  }
}
export default App;